import mediaDataTransformer from "features/shared/api/transformResponse/mediaDataTransformer"

const inventoryDetailTransformer = response => {
  let fixedFeature = []
  let additionalFeature = []
  !!response.FeatureCharges &&
    response.FeatureCharges.map(e => {
      if (e.fixed == 0) {
        additionalFeature?.push({ ...e })
      } else if (e.fixed == 1) {
        fixedFeature?.push({ ...e })
      }
    })
  let result = { ...response, fixedFeature: fixedFeature, additionalFeature: additionalFeature }
  return mediaDataTransformer(result)
}
export default inventoryDetailTransformer
